module.exports = __webpack_public_path__ + "img/people-37.efbd6f75.png";